import { fetchWithAuth } from "../helpers/fetchWithAuth";

/**
 * アドインの auth_access Cookie を用いて Web コンソール用ワンタイム handoff コードを取得する。
 *
 * - 成功 (200): `{ handoffCode, expiresIn }` を返す
 * - 認可拒否 (401): fetchWithAuth が refresh→retry を試み、それでも 401 なら `ReauthRequiredError` throw
 *   (生 fetch 直叩きだと長時間放置で access 期限切れになった瞬間に毎回失敗するため経由必須)
 * - ネットワーク失敗: `NetworkError` throw
 *
 * 取得した handoff_code は Web コンソール `/bridge?code=...` の URL に埋め込み、
 * `Office.context.ui.openBrowserWindow` で外部ブラウザを起動する。
 */
export async function createConsoleHandoffCode(): Promise<{
    handoffCode: string;
    expiresIn: number;
}> {
    const res = await fetchWithAuth("/user-tokens/console-handoff", { method: "POST" });
    if (!res.ok) {
        throw new Error(`Handoff code creation failed with status ${res.status}`);
    }
    const body = (await res.json()) as { handoff_code: string; expires_in: number };
    return { handoffCode: body.handoff_code, expiresIn: body.expires_in };
}
